import './routeBreadcrumb.scss';
import { ShipmentStop } from '../../apis/dtos';

interface RouteBreadcrumbProps {
  stop: ShipmentStop;
  nextStop: ShipmentStop | undefined;
}

type ConnectorClassName = 'blue-dash' | 'blue-solid';
type IconClassName =
  | 'circle-checked'
  | 'filled-location'
  | 'empty-location'
  | 'circle-outlined';

export const RouteBreadcrumb = ({
  stop,
  nextStop,
}: RouteBreadcrumbProps) => {
  const isFinalDestination = !nextStop;
  const stopActivity = stop.activities?.[0] ?? {};
  const carrierHasArrived = stopActivity.arrivedDateTime;
  const carrierHasLeft = stopActivity.departureDateTime;

  let before: ConnectorClassName = 'blue-dash';
  let after: ConnectorClassName = 'blue-dash';
  let icon: IconClassName = isFinalDestination ? 'empty-location' : 'circle-outlined';

  if (carrierHasArrived) {
    before = 'blue-solid';
  }

  if (carrierHasLeft) {
    after = 'blue-solid';
    icon = 'circle-checked';
  }

  if (carrierHasLeft && isFinalDestination) {
    icon = 'filled-location';
  }

  return (
    <div className="route-crumb no-print" data-testid="route-crumb">
      <div className={`connector ${before}`} data-testid="connector-before" />
      <span className={`icon ${icon}`} data-testid="icon" />
      <div className={`connector ${after}`} data-testid="connector-after" />
    </div>
  );
};
